// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarAddButton.tsx
import AddIcon from "@mui/icons-material/Add";
import I18n from "i18n-js";
import { Link } from "react-router-dom";
import Button from "./../../Button";
import { DataGridToolbarProps } from "./../DataGridToolbar";
import { useEditToolbar } from "./../useGridInlineEdit";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";
interface DataGridToolbarAddButtonProps extends DataGridToolbarProps {}

export default function DataGridToolbarAddButton({
  onCreate,
  apiRef,
  editUrl,
  buttonSize,
  createTitle,
}: DataGridToolbarAddButtonProps) {
  const { handleClick } = useEditToolbar({ apiRef: apiRef });

  const translation = createTitle || I18n.t("App.addNew");
  return (
    <DataGridToolbarButtonContainer>
      {onCreate ? (
        <Button
          size={buttonSize}
          startIcon={<AddIcon fontSize={buttonSize} />}
          onClick={() => onCreate()}
        >
          {translation}
        </Button>
      ) : editUrl ? (
        <Button
          size={buttonSize}
          //@ts-ignore
          to={editUrl.replace(":id", "create")}
          //@ts-ignore
          component={Link}
          startIcon={<AddIcon fontSize={buttonSize} />}
        >
          {translation}
        </Button>
      ) : (
        <Button
          size={buttonSize}
          startIcon={<AddIcon fontSize={buttonSize} />}
          onClick={handleClick}
        >
          {translation}
        </Button>
      )}
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarAddButton.tsx